$(document).ready(function() {
    var metafield = $('.t4s-tab-wrapper').data('id-symbol-fmp') || "";
    var param;  
    if (metafield.trim() !== "") {param = metafield;} 
    else {param = document.URL.split("products/")[1].split("?")[0].toUpperCase();}  
    $.getJSON('https://financialmodelingprep.com/api/v3/historical-price-full/'+param+'?timeseries=1&apikey=3ccf620ce9315de8a4996e601373f716', function(data){
      $.each(data, function(){
         $.each(this, function(j, elem){ 
           
           var Stock_price_open = elem.open;
           $('#stock_price_open').append(Stock_price_open);

            var Stock_price_close = Number(elem.close)
              .toFixed(2)
              .replace(/\.?0+$/, '');  
            $('#price').text(Stock_price_close);


           var Stock_price_low_calc = elem.low;
           var Stock_price_low = nFormatter(elem.low, 2);
           var Stock_price_high = nFormatter(elem.high, 2);
           
           if (!isNaN(Stock_price_low_calc)) {
             $('#day_range').append(Stock_price_low+'-'+Stock_price_high);
           };
           
        });
      });
    })
});


$(document).ready(function() {
    var metafield = $('.t4s-tab-wrapper').data('id-symbol-fmp') || "";
    var param;  
    if (metafield.trim() !== "") {param = metafield;} 
    else {param = document.URL.split("products/")[1].split("?")[0].toUpperCase();}  
    $.getJSON('https://financialmodelingprep.com/api/v3/historical-price-full/'+param+'?timeseries=2&apikey=3ccf620ce9315de8a4996e601373f716', function(data){
      var prices_array = new Array;
      $.each(data, function(){
         $.each(this, function(j, elem){ 
           
           var Stock_price_close_array = elem.close;
           if (!isNaN(Stock_price_close_array)) {
           prices_array.push([Stock_price_close_array]);
           };
           $('#stock_price_past_close').append(prices_array[1]);

           var Abs_delta_calc = prices_array[0] - prices_array[1];
           var Abs_delta = Abs_delta_calc.toFixed(2);
           if (!isNaN(Abs_delta_calc)) {
             $('#delta_absolute').append(Abs_delta);
           };

           var Perc_delta_calc = (prices_array[0] - prices_array[1]) / prices_array[1];
           var Perc_delta = Perc_delta_calc.toLocaleString('en-US', {style: 'percent', minimumFractionDigits:2});
           if (!isNaN(Perc_delta_calc)) {
             $('#delta_percent').append('('+Perc_delta+')');
                      
           };
           if (Perc_delta_calc * 1 < 0) {
             $('#delta_absolute').addClass('red_stock_price');
             $('#delta_percent').addClass('red_stock_price');
           };  
          
        });
      });
    })
});

